import { connect } from 'react-redux'
import { SocialConnectComponent } from './SocialConnectComponent'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'
import type { LoginForm } from 'shared/types'
import { onSocialPending } from 'shared/store/user'
import { push } from 'connected-react-router'
import { clearSigninRedirect } from 'shared/store/signin'
import { featureCodes } from 'shared/utils'

const mapStateToProps = (state: RootState) => ({
    ...state.userState,
    redirectToUrlAfterLogin: state.signinPageState.redirectToAfterLogin,
    enableNewOrderFlow:
        !!state.featuresState &&
        !!state.featuresState.available &&
        state.featuresState.available.includes(
            featureCodes.ENABLE_NEW_ORDER_FLOW
        )
})

const mapDispatchToProps = (d: Dispatch<any>) => ({
    socialConnect: (
        userData: LoginForm,
        fromLogin?: boolean,
        fromEcommerce?: boolean
    ) => d(onSocialPending(userData, fromLogin, fromEcommerce)),
    navigate: (to: string) => d(push(to)),
    goToRedirectAndReset: (url: string) => {
        d(clearSigninRedirect())
        d(push(url))
    }
})

const SocialConnect = connect(
    mapStateToProps,
    mapDispatchToProps
)(SocialConnectComponent)

export { SocialConnect }
